// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\Pilot\ApiPilot.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';
import { PilotAssignment, PilotAssignmentData, PilotAssignmentOptions } from 'data/models/PilotAssignment';
import { PilotSection, PilotSectionData, PilotSectionOptions } from 'data/models/PilotSection';

// PilotData is the class that Pilot serializes to/from
export interface PilotData {
    Id : number;
    Url : string | null;
	
    PilotJobOrders : PilotAssignmentData[] | null;
    Section : PilotSectionData | null;
    SectionId : number | null;
    User : PCUserData | null;
	
    Code : string | null;
    Order : number;
}

// PilotOptions is the class which may be passed to the Pilot constructor to define optional initial data values
export interface PilotOptions {
    Id : number;
    Url? : string | null;
	
    PilotJobOrders? : PilotAssignmentOptions[] | null;
    Section? : PilotSectionOptions | null;
    SectionId? : number | null;
    User? : PCUserOptions | null;
	
    Code? : string | null;
    Order? : number;
}

export class Pilot {
    public Id : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public PilotJobOrders : SDataArray<PilotAssignment>;
    public Section : DataSignal<PilotSection | null>;
    public SectionId : DataSignal<number | null>;
    public User : DataSignal<PCUser | null>;
	
    public Code : DataSignal<string | null>;
    public Order : DataSignal<number>;

    constructor();
    constructor(data : PilotOptions);
    constructor(data: PilotOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.PilotJobOrders = SArray<PilotAssignment>([]);
        this.Section = S.value<PilotSection | null>(null);
        this.SectionId = jsonableObservable(S.value<number | null>(data && data.SectionId !== undefined ? data.SectionId : null));
        this.User = S.value<PCUser | null>(null);
	    
        this.Code = jsonableObservable(S.value<string | null>(data && data.Code !== undefined ? data.Code : null));
        this.Order = jsonableObservable(S.value<number>(data && data.Order !== undefined ? data.Order : 0));
    }

    static key(obj : Pilot) {
        return obj.Id();
    }
    
    static dataKey(obj : PilotOptions) {
        return obj.Id;
    }

    static update(obj : Pilot, data : PilotOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
            if (data.SectionId !== undefined) obj.SectionId(data.SectionId);
	        
            if (data.Code !== undefined) obj.Code(data.Code);
            if (data.Order !== undefined) obj.Order(data.Order);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Pilot.ts